// This import loads the firebase namespace along with all its type information.
import MediationProcess from './mediation-process-model'

export async function load_mediationProcesss(): Promise<MediationProcess[]> {
  throw 'Not implemented'
}

export async function delete_mediationProcess(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediationProcess(): Promise<MediationProcess> {
  throw 'Not implemented'
}
